module.exports = __webpack_public_path__ + "static/media/AdoptionPackage.6c6c7391.svg";